import React from "react";
import { Chip } from "primereact/chip";
import Spinner from "./Spinner";

const chipTypeClasses = {
  primary: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-primary text-white capitalize",
  },
  secondary: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-gray-500 text-white capitalize",
  },
  success: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-success text-white capitalize",
  },
  danger: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-red-500 text-white capitalize",
  },
  warning: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-yellow-500 text-white capitalize",
  },
  blue: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-blue text-white capitalize",
  },
  gradient: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-gradient text-white capitalize border-primary !outline-none !shadow-none",
  },
  file: {
    base: "rounded-md !py-2 !px-3 !text-[14px] !bg-gray-200  text-gray-400 !font-semibold capitalize border-primary !outline-none !shadow-none",
  },
  first: {
    base: "rounded-md !py-2 !px-3 !text-[14px] !bg-blue  text-white !font-semibold capitalize border-primary !outline-none !shadow-none",
  },
  follow: {
    base: "rounded-md !py-2 !px-3 !text-[14px] !bg-yellow-500  text-white !font-semibold capitalize border-primary !outline-none !shadow-none",
  },
  emergency: {
    base: "rounded-md !py-2 !px-3 !text-[14px] !bg-red-500  text-white !font-semibold capitalize border-primary !outline-none !shadow-none",
  },
  default: {
    base: "rounded-full !py-1 !px-3 !text-[12px] bg-gray-400 text-white capitalize",
  },
  iconC: {
    base: "rounded-full !py-1 !px-3 !text-[12px] bg-iconC text-white capitalize",
  },
};

const CustomChip = ({
  label = "",
  title = "",
  icon = "",
  chipType = "default",
  className = "",
  onClick,
  removable = false,
  loading = false,
  labelClassName = "",
  onRemove,
  ...props
}) => {
  const { base, hover } = chipTypeClasses[chipType] || chipTypeClasses.default;

  return (
    <Chip
      title={title}
      label={loading ? <Spinner /> : label}
      icon={loading ? "" : icon}
      removable={removable}
      className={` ${base} ${hover} ${className} `}
      onClick={onClick}
      onRemove={onRemove}
      pt={{
        label: { className: `pl-2 ${labelClassName}` },
      }}
      {...props}
    />
  );
};

export default CustomChip;
